

/**
* @class
* @description Module which provides user manager capabilities
**/
export default  class Authentication{

    /**
     * @method CreateUser Create new user given user crediantials
     * @param {User} user New user credentials
     */
    CreateUser(){
        throw "Not implemented"
    } 

    /**
     * @method Login Login with user credentials if provided, otherwise with stored credentials
     * @param {User} user User credentials
     */
    Login(){
        throw "Not implemented"
    }

    /**
     * @method AcceptLA Accept License Agreement for current user
     */
    AcceptLA(){
        throw "Not implemented"
    }

    /**
     * @method Logout Log out from current user session
     */
    Logout(){
        throw "Not implemented"
    }

    /**
     * @method Credentials Retrieve from store credentials of logged user
     */
    Credentials(){
        throw "Not implemented"
    }
}